// extracted by mini-css-extract-plugin
module.exports = {"summary":"_3xbwDEQ9311GnJbVJ0RBh4","row":"_3xhGu-QXoIM_yFLXUgiO07"};